import React from "react";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import ApprovalOverrideCard from "./ApprovalOverrideCard";

const ApprovalOverrideList = ({ overrides, employees, schedules, statusFilter, handleOpenApprovalDialog }) => {
  const { t } = useTranslation();

  if (overrides.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center text-muted-foreground">
          <FileText className="h-12 w-12 mx-auto mb-2 text-gray-300" />
          <p>{t("planning.approvalsPanel.emptyTitle")}</p>
          <p className="text-sm mt-1">
            {statusFilter === "pending"
              ? t("planning.approvalsPanel.emptyPending")
              : t("planning.approvalsPanel.emptyFiltered")}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      {overrides.map((override) => (
        <ApprovalOverrideCard
          key={override.id}
          override={override}
          employees={employees}
          schedules={schedules}
          handleOpenApprovalDialog={handleOpenApprovalDialog}
        />
      ))}
    </div>
  );
};

export default ApprovalOverrideList;
